import React from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, Global } from '@emotion/react';

import { token } from '@atlaskit/tokens';

export function AIDefinitionsGlobalStyles() {
	return <Global styles={aiDefinitionsStyle} />;
}

// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/ensure-design-token-usage -- Ignored via go/DSP-18766
const aiDefinitionsStyle = css`
	.ai-definitions-keyword-decoration {
		position: relative;
		cursor: pointer;
	}

	// css from confluence/next/packages/contextual-reading-aids/src/RendererTextHighlighter.tsx
	.ai-definitions-keyword-styler {
		position: absolute;
		cursor: pointer;
		pointer-events: none;
		padding-bottom: ${token('space.025', '2px')};
		border-image: linear-gradient(to right, #0065ff, #bf63f3, #f5e6a8) 0 0 100% 0;
		border-width: 2px;
		border-bottom-style: solid;

		&-hover,
		&-active {
			background: linear-gradient(to right, rgba(0, 101, 255, 0.1), rgba(191, 99, 243, 0.1));
		}
	}
`;
